export type BulkFailure = {
  failed: boolean;
  assignmentCount: number;
};

export function buildSaveErrorMessage(
  failedCount: number,
  totalCount: number,
  reason: unknown,
  bulk?: BulkFailure,
): string {
  const detail = reason instanceof Error ? reason.message : "Failed to save changes.";
  const message =
    failedCount === totalCount
      ? `No changes were saved. ${detail}`
      : `Some changes were saved. ${failedCount} change(s) failed and are still shown as edited. ${detail}`;

  if (!bulk?.failed) return message;

  return `${message} None of the ${bulk.assignmentCount} assignments were applied.`;
}
